import {Injectable} from "@angular/core";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {Video} from "./video.model";

@Injectable()
export class YoutubeService {

  constructor(
    private sanitizer: DomSanitizer
  ) {
  }

  getEmbedUrl(video: Video): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${video.youtubeCode}`);
  }
}
